import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Icons, Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import TextInputWithLabel from '../../../../components/fields/TextInput/TextInputWithLabel';
import FieldDTOWithCol from '../../../../components/fields/Abstract/FieldDTOWithCol';
import JuridicalDTO from '../../../../dto/JuridicalDTO';
import FIOForm from './FIOForm';
import { addressTransform, companyNameTransform, responseLogWithNotification } from '../../../../utils/utils';
import CheckBoxInputWithLabel from '../../../../components/fields/CheckBoxInput/CheckBoxInputWithLabel';
import FieldDTO from '../../../../components/fields/Abstract/FieldDTO';
import { loadLegalEntityFormList } from '../../actions';
import SelectInputWithHelper from '../../../../components/fields/SelectInput/SelectInputWithHelper';
import AddressInput from '../../../../components/fields/Address/AddressInput';

export default function JuridicalForm(props) {
  const {
    prefix = '', disabled, control, formMeta, setValue, procedure,
    getValues,
    hideFileInput = false,
    watch = () => {},
    applicantType,
    isPreview = false,
    federal_law_number,
  } = props;
  const dispatch = useDispatch();
  const dto = new JuridicalDTO({ federal_law_number, legal_entity_type: applicantType });
  const attributes = dto.getAttributesByName();
  const [addressDisabled, setAddressDisabled] = useState(true);

  const firstAddress = `${prefix}${'legal_address'}`;
  const secondAddress = `${prefix}${'address'}`;

  React.useEffect(() => {
    const subscription = watch(values => {
      if (getValues(`${prefix}isMatch`)) {
        setAddressDisabled(true);
        if (getValues(secondAddress) !== getValues(firstAddress)) {
          setValue(secondAddress, getValues(firstAddress));
        }
        if (getValues(`${secondAddress}_normal`) !== getValues(`${firstAddress}_normal`)) {
          setValue(`${secondAddress}_normal`, getValues(`${firstAddress}_normal`));
          setValue(`${secondAddress}_json`, getValues(`${firstAddress}_json`));
          setValue(`${secondAddress}_json_string`, getValues(`${firstAddress}_json_string`));
        }
        return () => subscription.unsubscribe();
      }
      setAddressDisabled(false);
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  return (
    <>
      <Row className="row-cols-2">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.inn}
          variant="material"
          namePrefix={prefix}
          // disabled={disabled}
        />
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.ogrn}
          variant="material"
          namePrefix={prefix}
          // disabled={
          //     (
          //       (procedure === PROCEDURE_TYPE.PROCEDURE_1227_8 && applicantType === USER_TYPE.LEGAL)
          //         || (procedure === PROCEDURE_TYPE.PROCEDURE_1227_8 && applicantType === USER_TYPE.INDIVIDUAL_ENTREPRENEUR)
          //     )
          // }
        />
      </Row>
      <Row className={`row-cols-${!isPreview ? 3 : 2}`}>
        {!isPreview
          ? (
            <FieldDTO
              control={control}
              component={SelectInputWithHelper}
              dtoObject={attributes.legal_entity_form}
              namePrefix={prefix}
              portalClassName="executor-selector"
              loadAction={loadLegalEntityFormList}
              optionFormatter={item => ({ value: item.full_name, name: item.full_name })}
              variant="material"
              type="text"
              withLabel
            />
          ) : null }
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.full_name}
          transform={companyNameTransform}
          variant="material"
          namePrefix={prefix}
          // disabled={
          //         (
          //             ([PROCEDURE_TYPE.PROCEDURE_1227_3, PROCEDURE_TYPE.PROCEDURE_1228_3].includes(procedure) && applicantType === USER_TYPE.LEGAL)
          //             || (procedure === PROCEDURE_TYPE.PROCEDURE_1227_5 && applicantType === USER_TYPE.LEGAL)
          //             || (procedure === PROCEDURE_TYPE.PROCEDURE_1227_8 && applicantType === USER_TYPE.LEGAL)
          //         )
          //     }
        />
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.short_name}
          transform={companyNameTransform}
          variant="material"
          namePrefix={prefix}
          // disabled={
          //     (
          //       ([PROCEDURE_TYPE.PROCEDURE_1227_3, PROCEDURE_TYPE.PROCEDURE_1228_3].includes(procedure) && applicantType === USER_TYPE.LEGAL)
          //         || (procedure === PROCEDURE_TYPE.PROCEDURE_1227_5 && applicantType === USER_TYPE.LEGAL)
          //         || (procedure === PROCEDURE_TYPE.PROCEDURE_1227_8 && applicantType === USER_TYPE.LEGAL)
          //     )
          // }
        />
      </Row>
      <Row className="row-cols-1">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={AddressInput}
          dtoObject={attributes.legal_address}
          transform={addressTransform}
          variant="material"
          namePrefix={prefix}
          // disabled={
          //     (
          //       (procedure === PROCEDURE_TYPE.PROCEDURE_1228_3 && applicantType === USER_TYPE.LEGAL)
          //         || (procedure === PROCEDURE_TYPE.PROCEDURE_1227_8)
          //     )
          // }
        />
      </Row>
      <Row className="row-cols-1 ">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          label="Соответствует юридическому адресу"
          component={CheckBoxInputWithLabel}
          dtoObject={attributes.isMatch}
          variant="material"
          // disabled={disabled}
          namePrefix={prefix}
        />
      </Row>
      <Row className="row-cols-1">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={AddressInput}
          label="Адрес местонахождения"
          dtoObject={attributes.address}
          transform={addressTransform}
          variant="material"
          namePrefix={prefix}
          // disabled={
          //     (
          //       (procedure === PROCEDURE_TYPE.PROCEDURE_1228_3 && applicantType === USER_TYPE.INDIVIDUAL_ENTREPRENEUR)
          //         || (procedure === PROCEDURE_TYPE.PROCEDURE_1227_5)
          //         || (procedure === PROCEDURE_TYPE.PROCEDURE_1227_8)
          //     )
          // }
        />
      </Row>
      { !isPreview ? <FIOForm {...props} labelPrefix="manager_" /> : null }
      {/* <Row className="row-cols-2"> */}
      {/*  <FieldDTOWithCol */}
      {/*    control={control} */}
      {/*    formMeta={formMeta} */}
      {/*    type="text" */}
      {/*    component={TextInputWithLabel} */}
      {/*    dtoObject={attributes.phone} */}
      {/*    variant="material" */}
      {/*    namePrefix={prefix} */}
      {/*    // disabled={disabled} */}
      {/*  /> */}
      {/*  <FieldDTOWithCol */}
      {/*    control={control} */}
      {/*    formMeta={formMeta} */}
      {/*    type="text" */}
      {/*    component={TextInputWithLabel} */}
      {/*    dtoObject={attributes.email} */}
      {/*    variant="material" */}
      {/*    namePrefix={prefix} */}
      {/*    // disabled={disabled} */}
      {/*  /> */}
      {/* </Row> */}
    </>
  );
}
